import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    ctaButtonLabel: 'Upload document',
    description:
      'Make sure you include all the elements in the example below on one sheet of paper.',
    exampleDocumentImageAlt:
      'An example of the document that must be handwritten',
    nextSteps: [
      'A photocopy of your identity card (front and back) or your passport',
      'The exact text written in the example above (handwritten)',
      'The date and your signature',
      'Upload the document by clicking on the button below',
    ],
    title: 'Upload Identity verification (handwritten)',
  },
  fr: {
    ctaButtonLabel: 'Télécharger le document',
    description:
      'Suivez le guide\u00A0! Assurez-vous que tous les éléments ci-dessous figurent sur une seule et même page.',
    exampleDocumentImageAlt: 'Un exemple de document qui doit être manuscrit',
    nextSteps: [
      'Une photocopie de votre carte d’identité (recto et verso) ou de votre passeport',
      'La mention légale figurant sur l’exemple ci-dessous (écrite à la main).',
      'La date et votre signature',
      'Ajoutez le document en cliquant sur le bouton ci-dessous',
    ],
    title: 'Ajoutez votre attestation d’identité manuscrite',
  },
});

export default locales;
